export default __webpack_public_path__ + "static/media/notification.e9816109.svg";